import React from 'react';
import Img2 from '../images/form.png'; // Update the path to your image
import { Button, Form, Input, message, Row, Col } from 'antd';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS CSS


const ContactForm = () => {
  const [form] = Form.useForm();
  // Initialize AOS
  React.useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });
  }, []);

  // Handle form submission
  const handleSubmit = async (values) => {
    console.log(values)
    message.loading({ key:'contact-form', content: 'Submitting'});
    const response = await fetch('/api/mail', {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values)
    })
    const result = await response.json()
    const { success, error } = result
    if (success) {
      message.success({ key:'contact-form', content: 'Form submitted successfully!' });
    } else {
      message.success({ key:'contact-form', content: error });
    }

    form.resetFields();
  };

  return (
    <div>
      <section className="form-sec">
        <div className="container">
          <Row gutter={[30, 0]} align="middle" justify="center">
            {/* Image Section */}
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <div className="intro-mention-text" data-aos="fade-left">
                <div className="main-verter">
                  <img src={Img2} alt="form" />
                </div>
              </div>
            </Col>

            {/* Form Section */}
            {/* Form Section */}
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <div className="form-container">
                <h2>Contact us now</h2>
                <Form layout="vertical" onFinish={handleSubmit} form={form}>
                  {/* Full Name and Last Name in one line */}
                  <Row gutter={16}>
                    <Col xs={24} sm={12}>
                      <Form.Item name="firstName" label="Full Name">
                        <Input placeholder="Enter your full name" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item name="lastName" label="Last Name">
                        <Input placeholder="Enter your last name" />
                      </Form.Item>
                    </Col>
                  </Row>

                  {/* Email and Phone in one line */}
                  <Row gutter={16}>
                    <Col xs={24} sm={12}>
                      <Form.Item name="email" label="Email">
                        <Input placeholder="Enter your email" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item name="phone" label="Phone">
                        <Input placeholder="Enter your phone number" />
                      </Form.Item>
                    </Col>
                  </Row>

                  {/* Textarea in one line */}
                  <Form.Item name="message" label="Message">
                    <Input.TextArea
                      rows={4}
                      placeholder="Enter your message here"
                    />
                  </Form.Item>

                  {/* Submit Button */}
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Submit
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
};

export default ContactForm;